// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const TopLevelAlertTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.topLevelAlertTitle"
        description="Top level alert title."
        defaultMessage="Community Audience"
    />
);
TopLevelAlertTitle.displayName = "TopLevelAlertTitle";

export const TopLevelAlertDescription = (props: { link: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.topLevelAlertDescription"
        description="Top level alert description."
        defaultMessage="Community Audience is undergoing long-term maintenance and metrics improvements. It will be unavailable for some time, and we apologize for any inconvenience. Please reach out to {link} if you have any questions."
        values={props}
    />
);
TopLevelAlertDescription.displayName = "TopLevelAlertDescription";
